@if (selectedWorkspace$ | async; as selectedWorkspace) {
    @if (fieldTypes$ | async; as fieldTypes) {
        @if (workspaces$ | async; as workspaces) {
            @if (selectedSchema$ | async; as selectedSchema) {
                <ng-container *transloco="let tManageFields; read: 'manage_fields'">
                    <app-modal-layout
                        [containerLayout]="containerLayout"
                        (closeModal)="forceWithValidation()"
                        [showLoader]="showLoader"
                        [errors]="errors"
                    >
                        <ng-container title>{{ tManageFields('manage_fields') }}</ng-container>
                        <ng-container subtitle>{{
                            tManageFields('manage_fields_subtitle')
                        }}</ng-container>
                        <app-fields-collection
                            [accordionContent]="accordionContent"
                            [selectedWorkspace]="selectedWorkspace"
                            [excludedFieldTypes]="excludedFieldTypes"
                            [workspaces]="workspaces"
                            [selectedSchema]="selectedSchema.guid"
                            [fieldTypes]="fieldTypes"
                            [pinWorkspaces]="true"
                        >
                        </app-fields-collection>
                        <app-modal-layout-buttons buttons [primary]="true">
                            <app-tb-button
                                primary
                                (click)="addField(selectedWorkspace)"
                                class="w-full"
                                icon="add_circle_outline"
                            >
                                {{ tManageFields('add_field') }}
                            </app-tb-button>
                        </app-modal-layout-buttons>
                    </app-modal-layout>
                    <ng-template
                        #accordionContent
                        [appTypedTemplate]="contextType"
                        let-fieldTypes="fieldTypes"
                        let-workspaces="workspaces"
                        let-fields="fields"
                    >
                        <div class="flex flex-col w-full">
                            @for (field of fields; track field.guid) {
                                @if (
                                    getWorkspaceForField(field.workspace_guid, workspaces);
                                    as workspace
                                ) {
                                    <app-manage-fields-item
                                        [workspace]="workspace"
                                        [field]="field"
                                        [fieldType]="fieldTypes[field.field_type_code]"
                                        (deleteField)="deleteField($event)"
                                    ></app-manage-fields-item>
                                }
                            }
                        </div>
                    </ng-template>
                </ng-container>
            }
        }
    }
}
